import React from 'react';
import ITyped from 'react-ityped';
export default function Hero(){
  const strings = ['I am full stack developer', 'Digital Marketer', 'Freelance designer']
return(<>
<section id="hero" className="d-flex flex-column justify-content-center align-items-center">
    <div className="hero-container" data-aos="fade-in">
      <h1>Harshal Nirbhavane</h1>
      <p><ITyped className='typed  ityped-cursor'
            showCursor={false}
            strings={strings}
            typeSpeed={100}
            backSpeed={50}
            startDelay={100}
            backDelay={250}
        /></p>
      
    </div>
    
  </section>
</>);
}